import Text from "src/components/Displays/Text";
import { Box, CardMedia, Skeleton, Stack } from "@mui/material";
import b2cIphoneFrame from "src/assets/images/b2cIphoneFrame.png";
import b2cIphoneFrameLB from "src/assets/images/b2cIphoneFrameLB.png";

import PulseAnimation from "src/components/Animation/PulseAnimation";
import TariffProviderIcon from "../TarrifProviderIcon/TariffProbiderIcon";
import {
  battery,
  gridFeedIn,
  pvProduction,
  eCarCharging,
  houseConsumption,
  heatPumpConsumption,
} from "src/assets";
import { ThemeValues } from "../ThemeUsage/theme";

interface DesktopViewProps {
  data: any;
  uuid: string;
  theme: string;
}

const DesktopView = ({ uuid, data, theme }: DesktopViewProps) => {
  const getBgImage = () => {
    if (theme === ThemeValues.lichtblick) {
      return b2cIphoneFrameLB;
    }
    return b2cIphoneFrame;
  };

  return (
    <>
      <Stack
        sx={{
          gap: 5,
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack alignItems={"center"}>
          <Stack direction={"row"} alignItems={"center"}>
            <Text
              sx={(theme) => ({
                fontSize: "16px",
                fontWeight: "500",
                color: theme.palette.app.primaryFont,
              })}
              text={`B2C View Live Data`}
            />

            <TariffProviderIcon />
          </Stack>

          <Stack>
            <Box
              sx={{
                width: "400px",
                height: "750px",

                position: "relative",
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundImage: `url(${getBgImage()})`,
              }}
            >
              <Box
                sx={{
                  top: "190px",
                  left: "55px",
                  float: "left",
                  zIndex: "1000",
                  position: "absolute",
                }}
              >
                <Stack gap={3}>
                  <Stack direction={"row"} alignItems={"center"} gap={3}>
                    <Text
                      sx={(theme) => ({
                        fontSize: "20px",
                        fontWeight: "500",
                        lineHeight: "24px",
                      })}
                      text={`Dein Zuhause`}
                    />

                    <PulseAnimation
                      sx={{
                        width: "10px",
                        height: "10px",
                        background: "#ffa137",
                      }}
                    />

                    <Text
                      sx={(theme) => ({
                        fontSize: "12px",
                        fontWeight: "500",
                        lineHeight: "24px",
                      })}
                      text={`online`}
                    />
                  </Stack>

                  <Stack>
                    <Text
                      sx={(theme) => ({
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "15px",
                        letterSpacing: "0.02px",
                      })}
                      text={`Finde heraus \n wie viel Energie du \n produzierst, \n verbrauchst und ins \n Netz einspeist.`}
                    />
                  </Stack>
                </Stack>

                <Box height={20} />

                <Stack gap={2}>
                  <Stack direction={"row"} gap={2}>
                    <Box
                      sx={{
                        padding: 3,

                        height: "100px",
                        width: "140px",

                        bgcolor: "#FBF7F3",
                        borderRadius: "10px",
                        border: "1px solid #FCC274",
                      }}
                    >
                      <Stack height={"100%"}>
                        <Text
                          sx={(theme) => ({
                            color: "#262626",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "20px",
                            letterSpacing: "0.02px",
                          })}
                          text={`PV Produktion`}
                        />

                        <Stack
                          gap={2}
                          height={"100%"}
                          direction={"row"}
                          alignItems={"center"}
                        >
                          <Box height="38px" width="38px">
                            <CardMedia
                              component="img"
                              alt="pvProduction"
                              image={pvProduction}
                              sx={{ objectFit: "contain" }}
                            />
                          </Box>

                          {!data && (
                            <Skeleton width={"65px"} variant="rounded" />
                          )}
                          {data && (
                            <Text
                              sx={(theme) => ({
                                color: "#616161",
                                fontSize: "12px",
                                fontWeight: "600",
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                              })}
                              text={data.productionWatt + " W"}
                            />
                          )}
                        </Stack>
                      </Stack>
                    </Box>

                    <Box
                      sx={{
                        padding: 3,

                        height: "100px",
                        width: "140px",

                        borderRadius: "10px",
                        border: "1px solid #64C294",
                        bgcolor: "rgba(100, 194, 148, 0.15)",
                      }}
                    >
                      <Stack height={"100%"}>
                        <Text
                          sx={(theme) => ({
                            color: "#262626",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "20px",
                            letterSpacing: "0.02px",
                          })}
                          text={`Batterie`}
                        />

                        <Stack
                          gap={2}
                          height={"100%"}
                          direction={"row"}
                          alignItems={"center"}
                        >
                          <Box height="38px" width="38px">
                            <CardMedia
                              component="img"
                              alt="battery"
                              image={battery}
                              sx={{ objectFit: "contain" }}
                            />
                          </Box>

                          {!data && (
                            <Skeleton width={"65px"} variant="rounded" />
                          )}

                          {data && (
                            <Stack>
                              <Text
                                sx={(theme) => ({
                                  color: "#616161",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  lineHeight: "20px",
                                  letterSpacing: "0.02px",
                                })}
                                text={data.storageChargeWatt + " W"}
                              />

                              <Stack direction={"row"} gap={1}>
                                <PulseAnimation
                                  sx={{
                                    mt: "2px",
                                    width: "7px",
                                    height: "7px",
                                    background: "#64C294",
                                  }}
                                />
                                <Text
                                  sx={(theme) => ({
                                    color: "#616161",
                                    fontSize: "8px",
                                    fontWeight: "600",
                                    lineHeight: "10px",
                                    letterSpacing: "0.02px",
                                  })}
                                  text={"wird geladen"}
                                />
                              </Stack>
                            </Stack>
                          )}
                        </Stack>
                      </Stack>
                    </Box>
                  </Stack>

                  <Stack direction={"row"} gap={2}>
                    <Box
                      sx={{
                        padding: 3,

                        height: "100px",
                        width: "140px",

                        borderRadius: "10px",
                        border: "1px solid #DB7923",
                        bgcolor: "rgba(219, 121, 35, 0.15)",
                      }}
                    >
                      <Stack height={"100%"}>
                        <Text
                          sx={(theme) => ({
                            color: "#262626",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "20px",
                            letterSpacing: "0.02px",
                          })}
                          text={`Netzeinspeisung`}
                        />

                        <Stack
                          gap={2}
                          height={"100%"}
                          direction={"row"}
                          alignItems={"center"}
                        >
                          <Box height="38px" width="38px">
                            <CardMedia
                              component="img"
                              alt="gridFeedIn"
                              image={gridFeedIn}
                              sx={{ objectFit: "contain" }}
                            />
                          </Box>

                          {!data && (
                            <Skeleton width={"65px"} variant="rounded" />
                          )}

                          {data && (
                            <Text
                              sx={(theme) => ({
                                color: "#616161",
                                fontSize: "12px",
                                fontWeight: "600",
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                              })}
                              text={data.gridFeedInWatt + " W"}
                            />
                          )}
                        </Stack>
                      </Stack>
                    </Box>

                    <Box
                      sx={{
                        padding: 3,

                        height: "100px",
                        width: "140px",

                        borderRadius: "10px",
                        border: "1px solid #B9C7D8",
                        bgcolor: "rgba(185, 199, 216, 0.15)",
                      }}
                    >
                      <Stack height={"100%"}>
                        <Text
                          sx={(theme) => ({
                            color: "#262626",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "20px",
                            letterSpacing: "0.02px",
                          })}
                          text={`Haus Verbrauch`}
                        />

                        <Stack
                          gap={2}
                          height={"100%"}
                          direction={"row"}
                          alignItems={"center"}
                        >
                          <Box height="38px" width="38px">
                            <CardMedia
                              component="img"
                              alt="houseConsumption"
                              image={houseConsumption}
                              sx={{ objectFit: "contain" }}
                            />
                          </Box>

                          {!data && (
                            <Skeleton width={"65px"} variant="rounded" />
                          )}

                          {data && (
                            <Text
                              sx={(theme) => ({
                                color: "#616161",
                                fontSize: "12px",
                                fontWeight: "600",
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                              })}
                              text={data.consumptionHouseholdWatt + " W"}
                            />
                          )}
                        </Stack>
                      </Stack>
                    </Box>
                  </Stack>

                  <Stack direction={"row"} gap={2}>
                    <Box
                      sx={{
                        padding: 3,

                        height: "100px",
                        width: "140px",

                        borderRadius: "10px",
                        border: "1px solid #539D77",
                        bgcolor: "rgba(83, 157, 119, 0.15)",
                      }}
                    >
                      <Stack height={"100%"}>
                        <Text
                          sx={(theme) => ({
                            color: "#262626",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "20px",
                            letterSpacing: "0.02px",
                          })}
                          text={`E-Auto lädt`}
                        />

                        <Stack
                          gap={2}
                          height={"100%"}
                          direction={"row"}
                          alignItems={"center"}
                        >
                          <Box height="38px" width="38px">
                            <CardMedia
                              component="img"
                              alt="eCarCharging"
                              image={eCarCharging}
                              sx={{ objectFit: "contain" }}
                            />
                          </Box>

                          {!data && (
                            <Skeleton width={"65px"} variant="rounded" />
                          )}

                          {data && (
                            <Text
                              sx={(theme) => ({
                                color: "#616161",
                                fontSize: "12px",
                                fontWeight: "600",
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                              })}
                              text={data.consumptionEvseWatt + " W"}
                            />
                          )}
                        </Stack>
                      </Stack>
                    </Box>

                    <Box
                      sx={{
                        padding: 3,

                        height: "100px",
                        width: "140px",

                        borderRadius: "10px",
                        border: "1px solid #758EA5",
                        bgcolor: "rgba(117, 142, 165, 0.15)",
                      }}
                    >
                      <Stack height={"100%"}>
                        <Text
                          sx={(theme) => ({
                            color: "#262626",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "15px",
                            letterSpacing: "0.02px",
                          })}
                          text={`Wärmepumpe Verbrauch`}
                        />

                        <Stack
                          gap={2}
                          height={"100%"}
                          direction={"row"}
                          alignItems={"center"}
                        >
                          <Box height="38px" width="38px">
                            <CardMedia
                              component="img"
                              alt="heatPumpConsumption"
                              image={heatPumpConsumption}
                              sx={{ objectFit: "contain" }}
                            />
                          </Box>

                          {!data && (
                            <Skeleton width={"65px"} variant="rounded" />
                          )}

                          {data && (
                            <Text
                              sx={(theme) => ({
                                color: "#616161",
                                fontSize: "12px",
                                fontWeight: "600",
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                              })}
                              text={data.consumptionHpWatt + " W"}
                            />
                          )}
                        </Stack>
                      </Stack>
                    </Box>
                  </Stack>
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Stack>

        <Text
          sx={(theme) => ({
            fontSize: "16px",
            fontWeight: "500",
            color: theme.palette.app.primaryFont,
          })}
          text={`UUID: ${uuid}`}
        />
      </Stack>
    </>
  );
};

export default DesktopView;
